import { AchPaymentFilterModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { AchCompany } from './company.entity';
import { defaultAchPaymentFilterDto } from './data/ach.data';

export class AchPaymentFilter extends DomainEntity<AchPaymentFilterModelDto> {
    constructor(protected dto = defaultAchPaymentFilterDto) {
        super(dto);
    }

    private _achCompanyList = this.dto.achCompanyList
        ? this.dto.achCompanyList.map(c => new AchCompany(c))
        : [];

    public createDefault(): this {
        return new AchPaymentFilter() as this;
    }

    public get achType() {
        return this.dto.achType || 'All';
    }

    public set achType(achType) {
        this.dto.achType = achType;
    }

    public get status() {
        return this.dto.status || 'All';
    }

    public set status(status) {
        this.dto.status = status;
    }

    public get isRecurring() {
        return this.dto.isRecurring ?? false;
    }

    public set isRecurring(isRecurring) {
        this.dto.isRecurring = isRecurring;
    }

    public get isBasic() {
        return this.dto.isBasic;
    }

    public set isBasic(isBasic) {
        this.dto.isBasic = isBasic;
    }

    public get achCompanies() {
        return this._achCompanyList;
    }

    public set achCompanies(achCompanies) {
        this._achCompanyList = achCompanies;
        this.dto.achCompanyList = this.achCompanies.map(c => c.toDto());
    }

    public get batchName() {
        return this.dto.batchName || '';
    }

    public set batchName(batchName) {
        this.dto.batchName = batchName;
    }

    public get transactionId() {
        return this.dto.transactionId || '';
    }

    public set transactionId(transactionId) {
        this.dto.transactionId = transactionId;
    }

    public get secCode() {
        return this.dto.secCode || 'All';
    }

    public set secCode(secCode) {
        this.dto.secCode = secCode;
    }

    public get debitAmountType() {
        return this.dto.debitAmountType;
    }

    public set debitAmountType(debitAmountType) {
        this.dto.debitAmountType = debitAmountType;
    }

    public get debitAmount() {
        return this.dto.debitAmount;
    }

    public set debitAmount(debitAmount) {
        this.dto.debitAmount = debitAmount;
    }

    public get debitAmountMin() {
        return this.dto.debitAmountMin;
    }

    public set debitAmountMin(debitAmountMin) {
        this.dto.debitAmountMin = debitAmountMin;
    }

    public get debitAmountMax() {
        return this.dto.debitAmountMax;
    }

    public set debitAmountMax(debitAmountMax) {
        this.dto.debitAmountMax = debitAmountMax;
    }

    public get creditAmountType() {
        return this.dto.creditAmountType;
    }

    public set creditAmountType(creditAmountType) {
        this.dto.creditAmountType = creditAmountType;
    }

    public get creditAmount() {
        return this.dto.creditAmount;
    }

    public set creditAmount(creditAmount) {
        this.dto.creditAmount = creditAmount;
    }

    public get creditAmountMin() {
        return this.dto.creditAmountMin;
    }

    public set creditAmountMin(creditAmountMin) {
        this.dto.creditAmountMin = creditAmountMin;
    }

    public get creditAmountMax() {
        return this.dto.creditAmountMax;
    }

    public set creditAmountMax(creditAmountMax) {
        this.dto.creditAmountMax = creditAmountMax;
    }

    public get frequencies() {
        return this.dto.frequencies;
    }

    public set frequencies(frequencies) {
        this.dto.frequencies = frequencies;
    }

    public get initiatedDateType() {
        return this.dto.initiatedDateType;
    }

    public set initiatedDateType(initiatedDateType) {
        this.dto.initiatedDateType = initiatedDateType;
    }

    public get initiatedDate() {
        return this.dto.initiatedDate;
    }

    public set initiatedDate(initiatedDate) {
        this.dto.initiatedDate = initiatedDate;
    }

    public get initiatedDateStart() {
        return this.dto.initiatedDateStart;
    }

    public set initiatedDateStart(initiatedDateStart) {
        this.dto.initiatedDateStart = initiatedDateStart;
    }

    public get initiatedDateEnd() {
        return this.dto.initiatedDateEnd;
    }

    public set initiatedDateEnd(initiatedDateEnd) {
        this.dto.initiatedDateEnd = initiatedDateEnd;
    }

    public get effectiveDateType() {
        return this.dto.effectiveDateType;
    }

    public set effectiveDateType(effectiveDateType) {
        this.dto.effectiveDateType = effectiveDateType;
    }

    public get effectiveDate() {
        return this.dto.effectiveDate;
    }

    public set effectiveDate(effectiveDate) {
        this.dto.effectiveDate = effectiveDate;
    }

    public get effectiveDateStart() {
        return this.dto.effectiveDateStart;
    }

    public set effectiveDateStart(effectiveDateStart) {
        this.dto.effectiveDateStart = effectiveDateStart;
    }

    public get effectiveDateEnd() {
        return this.dto.effectiveDateEnd;
    }

    public set effectiveDateEnd(effectiveDateEnd) {
        this.dto.effectiveDateEnd = effectiveDateEnd;
    }

    public get nextPaymentDateType() {
        return this.dto.nextPaymentDateType;
    }

    public set nextPaymentDateType(nextPaymentDateType) {
        this.dto.nextPaymentDateType = nextPaymentDateType;
    }

    public get nextPaymentDate() {
        return this.dto.nextPaymentDate;
    }

    public set nextPaymentDate(nextPaymentDate) {
        this.dto.nextPaymentDate = nextPaymentDate;
    }

    public get nextPaymentDateStart() {
        return this.dto.nextPaymentDateStart;
    }

    public set nextPaymentDateStart(nextPaymentDateStart) {
        this.dto.nextPaymentDateStart = nextPaymentDateStart;
    }

    public get nextPaymentDateEnd() {
        return this.dto.nextPaymentDateEnd;
    }

    public set nextPaymentDateEnd(nextPaymentDateEnd) {
        this.dto.nextPaymentDateEnd = nextPaymentDateEnd;
    }
}
